import { environment } from 'src/environments/environment';
import { ImagilityBaseResponse } from './../../../data/models/response.model';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromVDTask from '../vd-state/reducers/vd.reducer';
import { take } from 'rxjs/operators';
import { UploadPdfService } from './upload-pdf.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'app-upload-pdf',
  templateUrl: './upload-pdf.component.html',
  styleUrls: ['./upload-pdf.component.scss']
})
export class UploadPdfComponent implements OnInit {
  uploadedFiles: any[] = [];
  visaId: number;
  uploadedFileName: string;
  fileList: {
    displayName: string,
    pdfURL: SafeResourceUrl,
    id: number,
    taskTypeId: number
  }[] = [];
  uploadedSuccessfully = false;
  isView: boolean = false;
  isEditVisa: boolean = false;

  constructor(
    private store: Store<any>,
    private uploadPdfService: UploadPdfService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.store.select(fromVDTask.getVDVisaId)
      .pipe(take(1))
      .subscribe((visaId: number) => {
        this.visaId = visaId;
        if (this.visaId) {
          this.getUploadedFiles();
        } else {
          this.router.navigate(['../../../../manage-visa/created-visas'], { relativeTo: this.route });
        }
      });
    this.route.params.subscribe((params) => {
      this.isView = (params['isView'] === 'view') ? true : false;
    });  
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
  }

  getUploadedFiles() {
    if (this.visaId) {
      this.uploadPdfService.getUploadedFiles(this.visaId)
        .pipe(take(1))
        .subscribe((response: ImagilityBaseResponse) => {
          if (response && response.data && response.data.length > 0) {
            this.fileList = (response.data as any[]).map((x, i) => {
              return {
                displayName: x.displayName ? x.displayName : `{{ displayName ${i} }}`,
                pdfURL: this.sanitizer.bypassSecurityTrustResourceUrl(
                  `${environment.appUrl}/${x.fileLocation}#toolbar=0&navpanes=0`),
                id: x.id,
                taskTypeId: x.taskTypeId
              };
            });
          } else {
            this.fileList = [];
          }
        });
    }
  }

  onUpload(fubauto) {
    const file: any = this.uploadedFiles[0];
    file.fileName = this.uploadedFileName;
    const payload = new FormData();
    payload.append('file', file, file.name);
    this.uploadPdfService.uploadVDPDF(this.visaId, payload, this.uploadedFileName)
      .pipe(take(1))
      .subscribe((response: any) => {
        if (response) {
          this.uploadedSuccessfully = true;
          this.getUploadedFiles();
          fubauto.clear();
          this.uploadedFiles.splice(0, this.uploadedFiles.length);
        }
      });
  }

  nextStep() {
    if(this.isView){
      this.router.navigate([`../../json-viewer/view`], { relativeTo: this.route });
    }else{
      this.router.navigate([`../json-viewer`], { relativeTo: this.route });
    }    
  }

  back() {
    if(this.isView){
      this.router.navigate([`../../task-details/view`], { queryParams: { id: this.visaId }, relativeTo: this.route });
    }else{
      this.router.navigate([`../task-details`], { queryParams: { id: this.visaId }, relativeTo: this.route });
    }    
  }

  onSelect(event) {
    this.uploadedFiles.splice(0, this.uploadedFiles.length);
    if (event.files && event.files.length > 0) {
      this.uploadedFileName = event.files[0].fileName = event.files[0].name;
      this.uploadedFiles.push(event.files[0]);
    }
  }

  deleteSelected(fubauto) {
    fubauto.clear();
    this.uploadedFiles.splice(0, this.uploadedFiles.length);
  }

  deleteUploaded(file: any) {
    this.uploadPdfService.deleteVDPDF(file.id)
      .pipe(take(1))
      .subscribe((response: boolean) => {
        if (response) {
          this.getUploadedFiles();
        }
      });
  }

}
